import { render, staticRenderFns } from "./qr-code-add.vue?vue&type=template&id=615267d3&"
import script from "./qr-code-add.vue?vue&type=script&lang=js&"
export * from "./qr-code-add.vue?vue&type=script&lang=js&"
import style0 from "./qr-code-add.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('615267d3')) {
      api.createRecord('615267d3', component.options)
    } else {
      api.reload('615267d3', component.options)
    }
    module.hot.accept("./qr-code-add.vue?vue&type=template&id=615267d3&", function () {
      api.rerender('615267d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/production-manage/qr-code/qr-code-add.vue"
export default component.exports